import axios, { AxiosResponse } from 'axios';
import { LoungeActionConstants } from '../utils/lounge-action-constant';

export interface ILoungeApi {
  getUrlLounge(subcriptionNumber: string, claimNumber: string, action: LoungeActionConstants): Promise<AxiosResponse<any>>;
}

class LoungeApi implements ILoungeApi {
  async getUrlLounge(subscriptionNumber: string, claimNumber: string, action: LoungeActionConstants): Promise<AxiosResponse<string>> {
    return await axios.get(`/api/lounge/url`, { params: { subscriptionNumber, claimNumber, action } });
  }
}
const loungeApi = new LoungeApi();

export { loungeApi };
